import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { CategoryResolvedConfigurationEffects } from './category-resolved-configuration.effects';
import { categoryResolvedConfigurationReducer } from './category-resolved-configuration.reducer';

export const provideCategoryResolvedConfigurationStore = () => [
  provideState('categoryResolvedConfiguration', categoryResolvedConfigurationReducer),
  provideEffects([CategoryResolvedConfigurationEffects]),
];
